import React, { useState } from 'react';
import { Star, Heart, MessageSquare, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const ALL_REVIEWS = [{
  user: '@carla_bienestar',
  text: 'Este libro me cambió la perspectiva. Sanar mi niña interior fue el primer paso para mi libertad emocional.',
  likes: 24,
  time: '2 horas'
}, {
  user: '@marian_luz',
  text: 'La lectura es súper profunda y sanadora. Me sentí muy identificada en cada página, es un proceso real de transformación.',
  likes: 18,
  time: '4 horas'
}, {
  user: '@sofi_crecimiento',
  text: 'Por fin entiendo por qué repetía ciertos patrones. Gracias por este material tan valioso.',
  likes: 31,
  time: '6 horas'
}, {
  user: '@ana_vibrando',
  text: 'El formato es súper cómodo y el diseño es hermoso. Me acompaña en mis mañanas de reflexión.',
  likes: 15,
  time: '8 horas'
}, {
  user: '@lau_sanacion',
  text: 'Lo recomiendo a todas mis amigas. Es un regalo para el alma que toda mujer debería tener.',
  likes: 42,
  time: '12 horas'
}, {
  user: '@valen_paz',
  text: 'Me ayudó a poner límites y a priorizarme sin culpa. Un antes y un después.',
  likes: 27,
  time: '1 día'
}, {
  user: '@pau_integral',
  text: 'Las meditaciones guiadas que vienen de regalo son el complemento perfecto.',
  likes: 19,
  time: '1 día'
}, {
  user: '@flor_alma',
  text: 'Siento que me hablo con más amor desde que empecé a leerlo. Gracias Sofía.',
  likes: 35,
  time: '2 días'
}, {
  user: '@agus_ser',
  text: 'Muy fácil de leer y aplicar. Ideal para quienes buscamos un cambio real.',
  likes: 22,
  time: '2 días'
}, {
  user: '@mery_consciente',
  text: 'Una inversión en una misma que vale totalmente la pena. ¡Gracias!',
  likes: 56,
  time: '3 días'
}];
export function Reviews() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (comment.trim()) {
      setShowPopup(true);
      setComment('');
      setRating(0);
    }
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, ALL_REVIEWS.length));
  };
  const ratingDistribution = [{
    stars: 5,
    count: 50,
    percentage: 96
  }, {
    stars: 4,
    count: 2,
    percentage: 4
  }, {
    stars: 3,
    count: 0,
    percentage: 0
  }, {
    stars: 2,
    count: 0,
    percentage: 0
  }, {
    stars: 1,
    count: 0,
    percentage: 0
  }];
  return <section className="py-24 bg-[#FEFEFE]" data-id="element-252">
      <div className="max-w-4xl mx-auto px-4" data-id="element-253">
        {/* Header */}
        <div className="text-center mb-16 space-y-4" data-id="element-254">
          <h2 className="text-3xl md:text-5xl font-serif text-[#2D2D2D] leading-tight" data-id="element-255">
            Lo que dicen nuestras lectoras
          </h2>
          <p className="text-[#666666] text-lg font-medium" data-id="element-256">
            Más de 50 mujeres ya comenzaron su proceso de transformación.
          </p>
        </div>

        {/* Summary Card */}
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-257">
          <div className="bg-white rounded-[2rem] p-8 shadow-xl shadow-pink-100/50 border border-[#FDF2F2] flex flex-col items-center justify-center text-center space-y-4" data-id="element-258">
            <div className="flex text-[#D4AF37] gap-1" data-id="element-259">
              {[...Array(5)].map((_, i) => <Star key={i} size={24} fill="currentColor" data-id="element-260" />)}
            </div>
            <div className="space-y-1" data-id="element-261">
              <p className="text-5xl font-serif font-bold text-[#2D2D2D]" data-id="element-262">
                4.9 / 5
              </p>
              <p className="text-[#999999] text-sm font-medium" data-id="element-263">
                Basado en 52 reseñas verificadas
              </p>
            </div>
            <div className="bg-[#FCE4EC] text-[#C2185B] px-4 py-2 rounded-full text-xs font-bold flex items-center gap-2" data-id="element-264">
              <span data-id="element-265">🤍</span>
              96% de las lectoras recomendarían este libro.
            </div>
          </div>

          <div className="bg-white rounded-[2rem] p-8 shadow-xl shadow-pink-100/50 border border-[#FDF2F2] space-y-4" data-id="element-266">
            {ratingDistribution.map(item => <div key={item.stars} className="flex items-center gap-4" data-id="element-267">
                <div className="flex items-center gap-1 w-12" data-id="element-268">
                  <span className="text-sm font-bold text-[#2D2D2D]" data-id="element-269">
                    {item.stars}
                  </span>
                  <Star size={12} fill="#D4AF37" className="text-[#D4AF37]" data-id="element-270" />
                </div>
                <div className="flex-1 h-2 bg-[#F5F5F5] rounded-full overflow-hidden" data-id="element-271">
                  <motion.div initial={{
                width: 0
              }} whileInView={{
                width: `${item.percentage}%`
              }} transition={{
                duration: 1,
                ease: 'easeOut'
              }} className="h-full bg-[#C2185B]" data-id="element-272" />
                </div>
                <span className="text-sm font-medium text-[#999999] w-8" data-id="element-273">
                  {item.count}
                </span>
              </div>)}
          </div>
        </div>

        {/* Review Form */}
        <div className="bg-[#FDF2F2]/50 p-8 rounded-[2rem] border border-[#FCE4EC] mb-16" data-id="element-274">
          <h3 className="text-[#2D2D2D] font-bold mb-6 text-center" data-id="element-275">
            Deja tu reseña para la comunidad:
          </h3>
          <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe aquí tu experiencia con el ebook..." className="w-full bg-white border border-[#FCE4EC] rounded-2xl p-6 text-[#2D2D2D] focus:border-[#C2185B] outline-none transition-colors mb-6 min-h-[120px] shadow-sm" data-id="element-276" />
          <div className="flex flex-wrap items-center justify-between gap-6" data-id="element-277">
            <div className="flex items-center gap-3" data-id="element-278">
              <span className="text-[#666666] text-sm font-medium" data-id="element-279">
                Calificar:
              </span>
              <div className="flex gap-1" data-id="element-280">
                {[1, 2, 3, 4, 5].map(s => <button key={s} onClick={() => setRating(s)} className={`${rating >= s ? 'text-[#D4AF37]' : 'text-[#E0E0E0]'} hover:scale-110 transition-transform`} data-id="element-281">
                    <Star size={24} fill={rating >= s ? 'currentColor' : 'none'} data-id="element-282" />
                  </button>)}
              </div>
            </div>
            <button onClick={handlePublish} className="bg-[#C2185B] text-white font-black px-10 py-4 rounded-full hover:bg-[#AD1457] transition-all transform hover:scale-[1.02] active:scale-[0.98] uppercase text-sm tracking-widest shadow-lg shadow-[#C2185B]/20" data-id="element-283">
              Publicar
            </button>
          </div>
        </div>

        {/* Review List */}
        <div className="space-y-12" data-id="element-284">
          {ALL_REVIEWS.slice(0, visibleCount).map((rev, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-b border-[#F5F5F5] pb-10 last:border-0" data-id="element-285">
              <div className="flex items-center justify-between mb-4" data-id="element-286">
                <div className="flex items-center gap-3" data-id="element-287">
                  <div className="w-10 h-10 bg-[#FCE4EC] rounded-full flex items-center justify-center text-[#C2185B] font-bold text-sm" data-id="element-288">
                    {rev.user.charAt(1).toUpperCase()}
                  </div>
                  <span className="text-[#2D2D2D] font-bold text-sm" data-id="element-289">
                    {rev.user}
                  </span>
                </div>
                <div className="flex text-[#D4AF37] gap-0.5" data-id="element-290">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-291" />)}
                </div>
              </div>
              <p className="text-[#4A4A4A] text-lg leading-relaxed mb-6 font-medium" data-id="element-292">
                "{rev.text}"
              </p>
              <div className="flex items-center gap-6 text-xs text-[#999999] font-medium" data-id="element-293">
                <button className="flex items-center gap-2 hover:text-[#C2185B] transition-colors" data-id="element-294">
                  <Heart size={16} data-id="element-295" /> {rev.likes} Likes
                </button>
                <span className="flex items-center gap-2" data-id="element-296">
                  <CheckCircle2 size={16} className="text-green-500" data-id="element-297" />
                  Compra verificada
                </span>
                <span data-id="element-298">hace {rev.time}</span>
              </div>
            </motion.div>)}

          {visibleCount < ALL_REVIEWS.length && <div className="text-center pt-8" data-id="element-299">
              <button onClick={loadMore} className="text-[#C2185B] font-black hover:text-[#AD1457] transition-colors uppercase text-sm tracking-[0.2em] border-b-2 border-[#C2185B] pb-1" data-id="element-300">
                Cargar más testimonios
              </button>
            </div>}
        </div>
      </div>

      <AnimatePresence data-id="element-301">
        {showPopup && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#2D2D2D]/40 backdrop-blur-sm" data-id="element-302">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white p-10 rounded-[2.5rem] max-w-sm w-full text-center shadow-2xl border border-[#FDF2F2]" data-id="element-303">
              <div className="w-20 h-20 bg-[#FCE4EC] rounded-full flex items-center justify-center mx-auto mb-6 text-[#C2185B]" data-id="element-304">
                <CheckCircle2 size={40} data-id="element-305" />
              </div>
              <h4 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-3" data-id="element-306">
                ¡Gracias, hermosa!
              </h4>
              <p className="text-[#666666] mb-8 leading-relaxed" data-id="element-307">
                Tu opinión es una luz para otras mujeres en su camino de
                sanación.
              </p>
              <button onClick={() => setShowPopup(false)} className="w-full bg-[#C2185B] text-white font-black py-4 rounded-full uppercase text-sm tracking-widest shadow-lg shadow-[#C2185B]/20" data-id="element-308">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}